<template>
  <div id="summer-landing-page">
    <!-- BODY -->
    <div
      id="navbar"
      class="header"
    >
      <div class="logo" />
      <div class="d-flex align-items-center">
        <TheLanguageSwitcher />
        <router-link
          :to="{ name: 'login' }"
          class="login button text-uppercase ml-2"
        >
          {{ $t('login') }}
        </router-link>
      </div>
    </div>

    <div class="sec-1">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1>{{ $t('summer-landing.title.1') }}</h1>
            <h2>{{ $t('summer-landing.title.2') }}</h2>
            <h2>{{ $t('summer-landing.title.3') }}</h2>
            <div class="lazy-load">
              <router-link :to="{ name: 'register' }">
                <b-img
                  alt="prizes"
                  :src="require('@/assets/images/landingSummer/paid.svg')"
                />
              </router-link>
              <div class="cont">
                <h2>150,000TL</h2>
                <p>{{ $t('summer-landing.already-paid-out') }}</p>
              </div>
              <div class="cont1">
                <h2>20,000</h2>
                <p>{{ $t('summer-landing.active-players') }}</p>
              </div>
            </div>
            <div>
              <a
                class="login button fb"
                @click="handleFacebookClick"
              >
                {{ $t('landing.header.sign-up-facebook') }}
              </a>
            </div>
            <div>
              <router-link
                :to="{ name: 'register' }"
                class="login button"
              >
                {{ $t('landing.header.sign-up-email') }}
              </router-link>
            </div>
          </div>
          <div class="col-lg-6 d-none d-lg-flex align-items-end">
            <router-link :to="{ name: 'register' }">
              <b-img
                alt="screenshot"
                class="responsive-image players"
                :src="require('@/assets/images/landingSummer/header-players.png')"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-2 d-none d-lg-block">
      <div class="container">
        <div class="row">
          <div class="col-4">
            <div class="rect rect--lightred">
              <div class="step">
                1
              </div>
              <div class="desc">
                <h2>{{ $t('summer-landing.carousel.1-1') }}</h2>
                <p>{{ $t('summer-landing.carousel.1-2') }}</p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="rect rect--red">
              <div class="step">
                2
              </div>
              <div class="desc">
                <h2>{{ $t('summer-landing.carousel.2-1') }}</h2>
                <p>{{ $t('summer-landing.carousel.2-2') }}</p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="rect rect--darkred">
              <div class="step">
                3
              </div>
              <div class="desc">
                <h2>{{ $t('summer-landing.carousel.3-1') }}</h2>
                <p>{{ $t('summer-landing.carousel.3-2') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-2 mob-carousel d-block d-lg-none">
      <div class="container">
        <div class="row">
          <div class="col">
            <carousel
              :responsive="{
                0:{
                  autoplay: true,
                  items:1,
                  nav:false,
                  dots: false,
                  loop: true
                },
                750:{
                  autoplay: true,
                  items:1,
                  nav:false,
                  dots: false,
                  loop: true
                },
                1000:{
                  autoplay: false,
                  items:3,
                  nav:false,
                  dots:false
                }
              }"
            >
              <div class="d-flex align-items-center justify-content-center">
                <div class="step">
                  1
                </div>
                <div class="desc">
                  <h2>{{ $t('summer-landing.carousel.1-1') }}</h2>
                  <p>{{ $t('summer-landing.carousel.1-2') }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center justify-content-center">
                <div class="step">
                  2
                </div>
                <div class="desc">
                  <h2>{{ $t('summer-landing.carousel.2-1') }}</h2>
                  <p>{{ $t('summer-landing.carousel.2-2') }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center justify-content-center">
                <div class="step">
                  3
                </div>
                <div class="desc">
                  <h2>{{ $t('summer-landing.carousel.3-1') }}</h2>
                  <p>{{ $t('summer-landing.carousel.3-2') }}</p>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-3 section">
      <div class="container">
        <div class="row">
          <div class="col-md-5 text-center">
            <router-link :to="{ name: 'register' }">
              <b-img
                alt="screenshot"
                class="responsive-image"
                :src="require(`@/assets/images/landingSummer/screen_${$i18n.locale}.jpg`)"
              />
            </router-link>
          </div>
          <div class="col-md-7">
            <h3>{{ $t('summer-landing.easy-and-free-to-play') }}</h3>
            <p>{{ $t('summer-landing.easy-and-free-to-play-text') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-4 section section--gray">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <h3>{{ $t('summer-landing.win-great-prizes') }}</h3>
            <p>{{ $t('summer-landing.win-great-prizes-text') }}</p>
          </div>
          <div class="col-md-5">
            <router-link :to="{ name: 'register' }">
              <b-img
                alt="prizes"
                class="responsive-image"
                :src="require('@/assets/images/landingSummer/prizes.png')"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-5 section">
      <div class="container">
        <div class="row">
          <div class="col-md-5 text-center">
            <router-link :to="{ name: 'register' }">
              <b-img
                alt="players"
                class="responsive-image"
                :src="require('@/assets/images/landingSummer/players.png')"
              />
            </router-link>
          </div>
          <div class="col-md-7">
            <h3>{{ $t('summer-landing.play-against-your-friends') }}</h3>
            <p>{{ $t('summer-landing.play-against-your-friends-text') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-6 section">
      <div class="container">
        <div class="row text-center">
          <div class="col">
            <h3>{{ $t('summer-landing.make-your-picks-and-start-winning-today') }}</h3>
            <div>
              <router-link
                :to="{ name: 'register' }"
                class="login button"
              >
                {{ $t('summer-landing.play-now') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-7 section section--gray d-none d-lg-block">
      <div class="container">
        <div class="row text-center">
          <div class="col">
            <h3>{{ $t('summer-landing.why-users-love-pick8') }}</h3>
            <div class="row">
              <div class="col-md-4">
                <p>“{{ $t('summer-landing.review_1') }}”</p>
                <div class="name">
                  Ekrem
                </div>
                <b-img
                  class="rating"
                  alt="rating"
                  :src="require('@/assets/images/landingSummer/rating.png')"
                />
              </div>
              <div class="col-md-4">
                <p>“{{ $t('summer-landing.review_2') }}”</p>
                <div class="name">
                  Azra
                </div>
                <b-img
                  alt="rating"
                  :src="require('@/assets/images/landingSummer/rating.png')"
                />
              </div>
              <div class="col-md-4">
                <p>“{{ $t('summer-landing.review_3') }}”</p>
                <div class="name">
                  Ayaz
                </div>
                <b-img
                  alt="rating"
                  :src="require('@/assets/images/landingSummer/rating.png')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sec-7 section section--gray d-block d-lg-none testimonials">
      <div class="container">
        <div class="row text-center">
          <div class="col">
            <h3>KULLANICILAR NEDEN PICK8'İ SEVİYOR</h3>

            <carousel
              id="testimonials"
              class="mt-4 "
              :responsive="{
                0:{
                  autoplay: true,
                  items:1,
                  nav:false,
                  dots: true,
                  loop: true
                },
                750:{
                  autoplay: true,
                  items:1,
                  nav:false,
                  dots: true,
                  loop: true
                },
                970:{
                  autoplay: false,
                  items:3,
                  nav:false,
                  dots:false
                }
              }"
            >
              <div class="align-items-center justify-content-center">
                <p>“Yıl boyunca farklı liglerle oynama şansına sahip olmayı seviyorum... bu daha fazla eğlence ve daha fazla kazanma şansı demek!”</p>
                <div class="name">
                  Ekrem
                </div>
                <b-row class="d-flex justify-content-center pt-3">
                  <b-col
                    :cols="5"
                  >
                    <b-img
                      alt="rating"
                      :src="require('@/assets/images/landingSummer/rating.png')"
                    />
                  </b-col>
                </b-row>
              </div>
              <div class="align-items-center justify-content-center">
                <p>“Bu oyunun en güzel yanı herkesin kazanma şansı olması - futbol dünyasını çok yakından takip etmeseniz bile! Beklemediğim bir şekilde skoru doğru tahmin ederek daha ikinci haftamda 25 TL kazandım.”</p>
                <div class="name">
                  Azra
                </div>
                <b-row class="d-flex justify-content-center pt-3">
                  <b-col
                    :cols="5"
                  >
                    <b-img
                      alt="rating"
                      :src="require('@/assets/images/landingSummer/rating.png')"
                    />
                  </b-col>
                </b-row>
              </div>
              <div class="align-items-center justify-content-center">
                <p>“Bu platformda her hafta oynamanıza gerek yok - ister oynar isterseniz ara verirsiniz, bu tamamen size bağlı. Kazanma şansımın daha yüksek olması için ben her hafta oynamaya çalışıyorum!”</p>
                <div class="name">
                  Ayaz
                </div>
                <b-row class="d-flex justify-content-center pt-3">
                  <b-col
                    :cols="5"
                  >
                    <b-img
                      alt="rating"
                      :src="require('@/assets/images/landingSummer/rating.png')"
                    />
                  </b-col>
                </b-row>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </div>

    <div class="footer section">
      <div class="container">
        <div class="row text-center">
          <div class="col">
            <p><strong>#pick8team</strong></p>
            <p>© 2019 PICK8. Ticari markalar ve marka isimleri ilgili sahiplerine aittir.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import TheLanguageSwitcher from '@/components/Molecules/TheLanguageSwitcher'

export default {
  name: 'SummerLandingPage',
  components: {
    TheLanguageSwitcher,
    carousel,
  },
  metaInfo() {
    return {
      meta: [
        { vmid: 'title', name: 'title', content: this.$t('page-titles.summer-landing') },
        { vmid: 'description', name: 'description', content: this.$t('page-descriptions.summer-landing') },
      ],
    }
  },
  methods: {
    callback() {
      location.reload()
    },
    handleFacebookClick() {
      const authUrl = process.env.VUE_APP_IS_MULTI_DOMAIN
        ? `${window.location.origin}/`
        : process.env.VUE_APP_AUTH_URL

      this.popup = window.open(
        `${authUrl}auth/facebook`,
        'login',
        `height=${600},width=${700}`
      )
      this.popup.window.focus()
      this.popup.onbeforeunload = this.callback
    },
  },
}
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/summer-landing.css";
  .rating {
    width: 150px !important;
  }
</style>
